var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workPermit" },
    [
      !_vm.hasTabAccess
        ? _c("p", [
            _vm._v("\n    " + _vm._s(_vm.$t("noTabPermission")) + "\n  "),
          ])
        : [
            !_vm.showDetail && _vm.items.length
              ? _c("div", { staticClass: "workPermit__toolbar" }, [
                  _c("div", { staticClass: "workPermit__toolbar-main" }, [
                    _vm.showApplyBtn
                      ? _c(
                          "div",
                          { staticClass: "workPermit__toolbar-apply" },
                          [
                            _c("div", { staticClass: "workPermit_hint" }, [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "termsAndConditions." +
                                        _vm.regionName +
                                        ".workPermit.hintForEdinburghTower",
                                      [_vm.$t("workPermit.types.WORK"), 5]
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "termsAndConditions." +
                                        _vm.regionName +
                                        ".workPermit.hintForOthers",
                                      [_vm.$t("workPermit.types.WORK"), 3]
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "HKLButton",
                              {
                                attrs: { color: "orange" },
                                on: {
                                  click: function ($event) {
                                    return _vm.navigateCreateWorkPermitPage()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("workPermit.applyWorkPermit")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn--darkblue workPermit__reset-filter",
                        attrs: { type: "button", role: "reset-filter-button" },
                        on: { click: _vm.resetFilters },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("action.resetFilter")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "table",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showDetail && _vm.items.length,
                    expression: "!showDetail && items.length",
                  },
                ],
                staticClass: "workPermit__summary",
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.itemHeaders, function (header, index) {
                      return _c(
                        "th",
                        { key: header.name + "_" + index, class: header.class },
                        [
                          _c(
                            "div",
                            {
                              class: {
                                "workPermit__header-title--sortable":
                                  header.attrPath,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  header.attrPath && _vm.sortByColumn(header)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(header.name) +
                                  "\n              "
                              ),
                              header.attrPath
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "workPermit__header-sort-icon",
                                    },
                                    [
                                      _vm.sortByAttr === header.attrPath
                                        ? _c("i", {
                                            class: [
                                              _vm.sortReverse
                                                ? "triangle-down"
                                                : "triangle-up",
                                            ],
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("tr", { staticClass: "workPermit__filter-row" }, [
                    _c("th"),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.SELECT,
                            type: "type",
                            trackBy: "val",
                            multiLabel: "label",
                            searchable: false,
                            options: _vm.typeFilterOptions,
                            onchange: _vm.updateFilterConditions,
                            value: _vm.typeFilterDisplayValue,
                            disabled: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.INPUT,
                            type: "code",
                            onchange: _vm.updateFilterConditions,
                            value: _vm.getFilterValue("code", ""),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.INPUT,
                            type: "description",
                            onchange: _vm.updateFilterConditions,
                            value: _vm.getFilterValue("description", ""),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.SELECT,
                            type: "status",
                            trackBy: "val",
                            multiLabel: "label",
                            searchable: false,
                            options: _vm.statusFilterOptions,
                            onchange: _vm.updateFilterConditions,
                            value: _vm.statusFilterDisplayValue,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.INPUT,
                            type: "building",
                            onchange: _vm.updateFilterConditions,
                            value: _vm.buildingFilterDisplayValue,
                            disabled: !_vm.isHKLDProject,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.INPUT,
                            type: "floor",
                            onchange: _vm.updateFilterConditions,
                            value: _vm.getFilterValue("floor", ""),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.INPUT,
                            type: "contractor",
                            onchange: _vm.updateFilterConditions,
                            value: _vm.getFilterValue("contractor", ""),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticClass: "duration-filter" },
                      [
                        _c("SearchFilter", {
                          attrs: {
                            inputType: _vm.INPUT_TYPE.DATE,
                            type: "duration",
                            disabledDate: false,
                            onchange: _vm.updateFilterConditions,
                            value: _vm.getFilterValue("duration", ["", ""]),
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.sortedFilteredItems, function (item, index) {
                      return [
                        _c(
                          "tr",
                          {
                            key: item.id,
                            class: [
                              "workPermit__item",
                              "workPermit__item-" +
                                (index % 2 ? "odd" : "even"),
                            ],
                          },
                          [
                            _c("td", [
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showCollapse(item),
                                    expression: "showCollapse(item)",
                                  },
                                ],
                                class: [
                                  "tree-arrow pointer",
                                  item.collapsed
                                    ? "fa-angle-right"
                                    : "fa-angle-down",
                                  "fa angle",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.switchArrow(item)
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "bold" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.workPermitTypeLabel(item.type)) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  class: { link_text: !_vm.excludeDraft(item) },
                                  on: {
                                    click: function ($event) {
                                      !_vm.excludeDraft(item) &&
                                        _vm.viewWorkPermit(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.code || _vm.emptyValue) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(item.workType || _vm.emptyValue)),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("customStatusLabel")(
                                    _vm.formatStatus(item.status)
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.getBuilding(item) || _vm.emptyValue)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.getFloors(item)))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  (item.contractor || {}).name || _vm.emptyValue
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.getDuration(item)))]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(item.hoistings, function (hoisting) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !item.collapsed,
                                  expression: "!item.collapsed",
                                },
                              ],
                              key: hoisting.id,
                              class: [
                                "workPermit__item",
                                "workPermit__item-" +
                                  (index % 2 ? "odd" : "even"),
                              ],
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.workPermitTypeLabel(hoisting.type)
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.hotWorkRequired(hoisting)
                                  ? _c("img", {
                                      attrs: {
                                        src: "/ic_hotwork.png",
                                        alt: "hotwork",
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      link_text: !_vm.excludeDraft(item),
                                    },
                                    on: {
                                      click: function ($event) {
                                        !_vm.excludeDraft(item) &&
                                          _vm.viewWorkPermit(item, hoisting.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          hoisting.code || _vm.emptyValue
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(hoisting.description || _vm.emptyValue)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("customStatusLabel")(
                                      _vm.formatStatus(hoisting.status)
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getBuilding(hoisting) || _vm.emptyValue
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getFloors(hoisting))),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    (hoisting.contractor || {}).name ||
                                      _vm.emptyValue
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getDuration(hoisting))),
                              ]),
                            ]
                          )
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !(_vm.showDetail || _vm.items.length),
                    expression: "!(showDetail || items.length)",
                  },
                ],
                staticClass: "workPermit_empty",
              },
              [
                _vm.isMainUser || _vm.isSubUser || _vm.isCurrentVendorAccount
                  ? _c("div", [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "termsAndConditions." +
                                _vm.regionName +
                                ".workPermit.hintForTenantApplyWorkPermit"
                            )
                          ),
                        },
                      }),
                    ])
                  : _c("p", { staticClass: "bold" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("workPermit.youHaveNoWorkPermit")) +
                          "\n      "
                      ),
                    ]),
                _vm._v(" "),
                _vm.showFirstApplyBtn
                  ? [
                      _c(
                        "HKLButton",
                        {
                          attrs: {
                            color: _vm.enableFirstApplyButton
                              ? "orange"
                              : "disabledgrey",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.nextAction()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("workPermit.applyWorkPermit")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.enableFirstApplyButton && _vm.isMainUser
                        ? _c("MainApplyModal", { ref: "modal" })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.enableFirstApplyButton &&
                      !_vm.isMainUser &&
                      _vm.isSubUser
                        ? _c("SubApplyModal", { ref: "modal" })
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showDetail,
                    expression: "showDetail",
                  },
                ],
              },
              [
                _c("div", { staticClass: "back" }, [
                  _c("i", { on: { click: _vm._backToSummary } }, [
                    _vm._v("< " + _vm._s(_vm.$t("workPermit.backToList"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("WorkPermitDetail", {
                  ref: "workPermitDetail",
                  attrs: {
                    focusPermitId: _vm.focusPermitId,
                    isPPSuspened: _vm.isPPSuspened,
                    projectPermit: _vm.projectPermit,
                    isProjectAvailable: _vm.isProjectAvailable,
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }